export const FEEDBACK_OPEN = Symbol('feedback.open')

export const FEEDBACK_EVENT_BEFORE_NEXT = Symbol('feedback.event.beforeNext')

export const FEEDBACK_EVENT_BEFORE_PREV = Symbol('feedback.event.beforePrev')

export const FEEDBACK_EVENT_NEXT = Symbol('feedback.event.next')

export const FEEDBACK_EVENT_PREV = Symbol('feedback.event.prev')

export const FEEDBACK_EVENT_AFTER_NEXT = Symbol('feedback.event.afterNext')

export const FEEDBACK_EVENT_AFTER_PREV = Symbol('feedback.event.afterPrev')
